/* eslint-disable */
import React,{ useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import DoneIcon from '@material-ui/icons/Done';
import history from 'legacy/containers/History';
import styles from './Forms.css';
import TextInput from '../../containers/Forms/components/TextInput';
import FormattedDate from '../../../views/components/Common/FormattedDate';
import { forEach } from 'lodash';
import { getEosSumaryReportStatus, getEosReportDownload } from "../../pages/PatientFile/module";

const KardiaRxReport = (props) => {
  const dispatch = useDispatch();
  const enrollmentOverview = useSelector(state => state.app.dataSources &&
    state.app.dataSources.enrolledPatientOverview &&
    state.app.dataSources.enrolledPatientOverview.data &&
    state.app.dataSources.enrolledPatientOverview.data.latest_enrollment);
  const tempIdtfConnection = props.location.search.split('idtf_connection_id=');
  const enrolledIdtfConnectionId = enrollmentOverview && enrollmentOverview.idtf_connection_id
  useEffect(() => {
    dispatch(getEosSumaryReportStatus(tempIdtfConnection[1] || enrolledIdtfConnectionId));
  }, []);
  const me = useSelector(state => state.app.dataSources.me);
  const KardiaRxECGs = useSelector(state => state.kardiaRx.kardiaRxIDTFEcg);
  let totalRecodings = 0;
  let totalMdnRecordings = 0;
  const eosSummaryStatus = useSelector(state => state.patientFile && state.patientFile.eosSummaryReportStatus);
  
  if (
    KardiaRxECGs.recordings &&
    KardiaRxECGs.recordings.data &&
    KardiaRxECGs.recordings.data.length &&
    KardiaRxECGs.recordings.data[0].length
  ) {
    totalRecodings = KardiaRxECGs.recordings.data[0].length;
    KardiaRxECGs.recordings.data[0].forEach(item => {
      if (item.acuity === 'mdn') {
        totalMdnRecordings = totalMdnRecordings + 1;
      }
    });
  }

  let serviceDate = null;
  if (
    KardiaRxECGs.recordings &&
    KardiaRxECGs.recordings.data &&
    KardiaRxECGs.recordings.data.length &&
    KardiaRxECGs.recordings.data[0].length &&
    KardiaRxECGs.recordings.data[0][0].date
  ) {
    serviceDate = KardiaRxECGs.recordings.data[0][0].date;
  }

  const handleClickReport = () => {
    // console.log("report=>>", "handle Report");
    dispatch(getEosReportDownload(tempIdtfConnection[1]));

  }

  const handleViewReport = () => {
    if(
      KardiaRxECGs &&
      KardiaRxECGs.selectedPatinet &&
      KardiaRxECGs.selectedPatinet.participantId 
      )
    history.push(`/${KardiaRxECGs.selectedPatinet.participantId}/eos/${tempIdtfConnection[1]}/e-sign`);

  }

  let reportStatus = '';
  if(eosSummaryStatus && moment(eosSummaryStatus.endServicePeriod) > moment()) {
    reportStatus = 'active'
  } else {
    reportStatus = eosSummaryStatus && eosSummaryStatus.status
  }

  return (
    <form>
      <div className={styles.reportFormSection}>
        <div style={{ display: 'flex', marginTop: '10px' }}>
          <p
            className={styles.label}
            style={{ display: 'grid', width: '25vh' }}
          >
            EOS Report Status:
            <span>
            {
            reportStatus == 'active' &&
              <button
                type="button"
                className={styles.PendingReportButton}
                disabled
               // onClick={() => this.toggleRevokePopover()}
                data-action="button-cancel-order"
                data-label="Pending"
              >
                ACTIVE STUDY
                <AccessTimeIcon style={{marginLeft: '20px'}}/>
              </button>
            }
            
            {
            reportStatus == 'pending' &&
            <button
              type="button"
              className={styles.PendingReportButton}
              disabled
              // onClick={() => this.toggleRevokePopover()}
              data-action="button-cancel-order"
              data-label="Pending"
            >
              REPORT PENDING
              <AccessTimeIcon style={{marginLeft: '10px'}}/>
            </button>
            }
            
            {
            reportStatus == 'signed' &&
            <button
              type="button"
              className={styles.SignedReportButton}
              disabled
              // onClick={() => this.toggleRevokePopover()}
              data-action="button-cancel-order"
              data-label="Pending"
            >
              SIGNED
              <DoneIcon style={{marginLeft: '10px', color: 'white'}}/>
            </button>
            }

            {
            reportStatus == 'ready' &&
            <button
              type="button"
              className={styles.ReadyReportButton}
              disabled
              // onClick={() => this.toggleRevokePopover()}
              data-action="button-cancel-order"
              data-label="Pending"
            >
              READY
              <DoneIcon style={{marginLeft: '10px', color: '#2D9F86'}}/>
            </button>
            }
            </span>
          </p>
          <p
            className={styles.label}
            style={{ display: 'grid', width: '25vh' }}
          >
            Service Period:
            {/* <span><FormattedDate date={serviceDate} /></span> */}
            <span className={styles.serviceColor}>{ eosSummaryStatus && eosSummaryStatus.startServicePeriod && moment(new Date(eosSummaryStatus.startServicePeriod)).format("MM-DD-YYYY")} - { eosSummaryStatus && eosSummaryStatus.endServicePeriod && moment(new Date(eosSummaryStatus.endServicePeriod)).format("MM-DD-YYYY") }</span>
          </p>
          <p
            className={styles.label}
            style={{ display: 'grid', width: '25vh' }}
          >
            Total Recordings:
            {/* <span>{totalRecodings}</span> */}
            <span className={styles.serviceColor}>{eosSummaryStatus && eosSummaryStatus.recordingsCountInfo && eosSummaryStatus.recordingsCountInfo.total}</span>
          </p>
          <p
            className={styles.label}
            style={{ display: 'grid', width: '25vh' }}
          >
            Total MDN:
            {/* <span>{totalMdnRecordings}</span> */}
            <span className={styles.serviceColor}>{eosSummaryStatus && eosSummaryStatus.recordingsCountInfo && eosSummaryStatus.recordingsCountInfo.mdn}</span>

          </p>
          {/* View Report to be shown only in case of KM6L Device Type */}
          {enrollmentOverview && (enrollmentOverview.device==null || enrollmentOverview.device=='KM6L') && <button
            type="button"
            style={{ marginTop: '20px' }}
            className={styles.viewReport}
            disabled ={ eosSummaryStatus && (eosSummaryStatus.status=='ready' || eosSummaryStatus.status=='signed') ? false : true}
            onClick={() => handleViewReport()}
            data-action="button-cancel-order"
            data-label="View Report"
          >
            View Report
          </button>}
          <button
            type="button"
            style={{ marginTop: '20px' }}
            className={styles.downloadReport}
            disabled ={ eosSummaryStatus && (eosSummaryStatus.status=='ready' || eosSummaryStatus.status=='signed') ? false : true}
            onClick={() => handleClickReport()}
            data-action="button-cancel-order"
            data-label="View Report"
          >
            Download Report
          </button>
        </div>
      </div>
    </form>
  );
};

export default KardiaRxReport;



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/KardiaRxReport.jsx